import { UTSLocale } from "@smile2impress/attraction-constants";
import { createContext, useContext } from "react";

type ContextProps = {
    locale: UTSLocale;
};
export const UTSLocaleContext = createContext<ContextProps>({
    locale: UTSLocale.SPAIN_ES,
});

export const useUTSLocaleContext = (): ContextProps =>
    useContext(UTSLocaleContext);
